import { BaseContext } from '../../../utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../uicomponent';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import { RadialProgressBarCSSStyle, RadialProgressBarCSSStyleImpl } from './radialprogressbarcss';
import { RadialProgressBarViewImpl } from './radialprogressbarview';
import './radialprogressbar.css';
// import * as $ from 'jquery';

export interface RadialProgressBarComponentProps extends UIComponentProps
{
    id: string;
    cssId?:string;
    percentage: number;
    cssStyle:RadialProgressBarCSSStyle;//children as any ..send play as prop 
    children:any;
}

export interface RadialProgressBarComponentState extends UIComponentState
{
    
}

export class RadialProgressBarComponent extends UIComponentImpl<RadialProgressBarComponentProps, UIComponentState, UIDataModel>
{

    constructor(props: RadialProgressBarComponentProps)
    {
        super(props);
    }
    
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new RadialProgressBarViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new RadialProgressBarCSSStyleImpl(applicationContext);
    }

    componentDidMount()
    {
        this.updateDonutChart(this.props.percentage, true);
    }

    UNSAFE_componentWillReceiveProps(nextProps: RadialProgressBarComponentProps)
    {
        this.setState({
            percenatge: nextProps.percentage});
            this.updateDonutChart(nextProps.percentage, true);
    }
    updateDonutChart (percent: number, donut: boolean) 
    {
        let el: any = "#"+this.props.id;
        percent = Math.round(percent);
        if (percent > 100) {
            percent = 100;
        } else if (percent < 0) {
            percent = 0;
        }
        var deg = Math.round(360 * (percent / 100));
    
        if (percent > 50) {
            $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
            $(el + ' .right-side').css('transform', 'rotate(180deg)');
        } else {
            $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
            $(el + ' .right-side').css('transform', 'rotate(0deg)');
        }
        if (donut) {
            $(el + ' .right-side').css('border-width', '0.1em');
            $(el + ' .left-side').css('border-width', '0.1em');
            $(el + ' .shadow').css('border-width', '0.1em');
        } else {
            $(el + ' .right-side').css('border-width', '0.5em');
            $(el + ' .left-side').css('border-width', '0.5em');
            $(el + ' .shadow').css('border-width', '0.5em');
        }
        $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/radialprogressbar/radialprogressbarcomponent.tsx